<!-- Zweck: Stellt die HTML-Struktur für shop warenkorb box component im Frontend bereit. -->
@if (warenkorb) {
  <div [class.warenkorbbox]="!ajax_mode">
    <div class="paddedcontent">
      <div>
        <div class="boxleft">
          <feature-block [features]="['Lieferantenbestellung']">
            <permission-block [allOfRoles]="['Lieferantenbestellung']">
              <mat-form-field style="margin-right: 5px; margin-bottom: 5px" appearance="outline">
                <mat-label>Lieferant</mat-label>
                <mat-select [(ngModel)]="warenkorb.supplierId" (selectionChange)="supplierSelected()">
                  @for (supp of suppliers|async; track supp.id) {
                    <mat-option [value]="supp.id.toString()">{{ supp.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </permission-block>
          </feature-block>
          <mat-checkbox (change)="change()" [(ngModel)]="group_val" class="tut_warenkorb_group">Gruppieren
          </mat-checkbox>
          @if (warenkorb.supplierId == 'JGM' && cfg.domainconfig.import_enabled && !(usvc.user$|async)?.readonly_impersonated) {
            <mat-checkbox (change)="saveAutoImp()" [(ngModel)]="warenkorb.autosend_imp" class="tut_warenkorb_impsend"
                          style="margin-left: 10px">Importservice
              automatisch absenden
            </mat-checkbox>
          }
        </div>
        @if (!ajax_mode) {
          <div class="boxright">
            <mat-form-field appearance="outline" style="margin-right: 5px;">
              <mat-label>Filter</mat-label>
              <input matInput type="text" [(ngModel)]="filter" placeholder="Filter">
              <span matSuffix>
                <button mat-icon-button (click)="filter = ''" [disabled]="!filter">
                  <svg-icon>error-clean</svg-icon>
                </button>
              </span>
            </mat-form-field>
            <view-field-selector label="Anzuzeigende Felder" [(fields)]="active_fields" [hidden_fields]="['hersteller']"
                                 (change)="updateFields()"></view-field-selector>
          </div>
        }
        <div style="clear: both"></div>
      </div>
      <ngx-simplebar #wkscroll [class.mobile]="msvc.isMobile()|async" [class.wkscroll]="!widget_mode && !ajax_mode"
                     [class.wkscroll_ajax]="ajax_mode">
        <div>
          @if (cfg.domainconfig.show_warenkorb_note !== false) {
            <div style="display: inline-block; vertical-align: top">
              <mat-form-field class="tut_warenkorb_note" appearance="outline" style="margin-top: 5px">
                <mat-label>Notiz</mat-label>
                <textarea (keydown)="note_edited = true" [(ngModel)]="warenkorb.note" matInput
                ></textarea>
                <mat-hint>Wird nicht übertragen!</mat-hint>
              </mat-form-field>
            </div>
          }
          <permission-block [oneOfRoles]="['Vertreter']">
            @if ((vsvc.$vertreterconfig|async)?.DomainVertreterShowReTage) {
              <div
                style="display: inline-block; margin-left: 10px; vertical-align: top">
                @if ((vsvc.$vertreterconfig|async)?.DomainVertreterShowReTageAuswahlListe.length >= 1) {
                  <mat-form-field class="tut_warenkorb_reTage" appearance="outline" style="margin-top: 5px">
                    <mat-label>Rechnungstage</mat-label>
                    <mat-select [(ngModel)]="warenkorb.reTage" (selectionChange)="reTageSelected()"
                                [canSelectNullableOptions]="true">
                      <mat-option [value]="null">Standard</mat-option>
                      @for (reTageOption of (vsvc.$vertreterconfig|async)?.DomainVertreterShowReTageAuswahlListe; track reTageOption) {
                        <mat-option [value]="reTageOption">{{ reTageOption }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                } @else {
                  <mat-form-field class="tut_warenkorb_reTage" appearance="outline" style="margin-top: 5px">
                    <mat-label>Rechnungstage:</mat-label>
                    <input matInput type="number" [(ngModel)]="warenkorb.reTage" step="1" min="0"
                           (keydown)="reTageSelected()" (change)="reTageSelected()">
                    <mat-hint>Leer lassen = Standard</mat-hint>
                  </mat-form-field>
                }
              </div>
            }
            @if ((vsvc.$vertreterconfig|async)?.DomainVertreterShowValutaDatum) {
              <div
                style="display: inline-block; margin-left: 10px; vertical-align: top">
                <mat-form-field class="tut_warenkorb_note" appearance="outline" style="margin-top: 5px">
                  <mat-label>Valuta Datum</mat-label>
                  <input matInput [matDatepicker]="valutaPicker" [ngModel]="valutaDate"
                         (dateChange)="valutaSelected($event)">
                  <span matSuffix>
                    <mat-datepicker-toggle [for]="valutaPicker"></mat-datepicker-toggle>
                  </span>
                  <mat-datepicker #valutaPicker></mat-datepicker>
                </mat-form-field>
              </div>
            }
            @if ((vsvc.$vertreterconfig|async)?.DomainVertreterShowLiefernAbDatum) {
              <div
                style="display: inline-block; margin-left: 10px">
                <mat-form-field class="tut_warenkorb_note" appearance="outline" style="margin-top: 5px">
                  <mat-label>Liefern ab</mat-label>
                  <input matInput [matDatepicker]="liefernAbPicker" [ngModel]="liefernAbDate"
                         (dateChange)="liefernAbSelected($event)">
                  <span matSuffix>
                    <mat-datepicker-toggle [for]="liefernAbPicker"></mat-datepicker-toggle>
                  </span>
                  <mat-datepicker #liefernAbPicker></mat-datepicker>
                </mat-form-field>
              </div>
            }
            @if ((vsvc.$vertreterconfig|async)?.DomainVertreterShowExterneKopfreferenz) {
              <div
                style="display: inline-block; margin-left: 10px">
                <mat-form-field class="tut_warenkorb_externeKopfreferenz" appearance="outline" style="margin-top: 5px"
                                [maxlength]="36">
                  <mat-label>Auftragsnummer</mat-label>
                  <input type="text" matInput [(ngModel)]="warenkorb.externeKopfreferenz"
                         (keyup)="validateExterneKopfreferenz()">
                  <mat-hint>Max. 36 Zeichen</mat-hint>
                </mat-form-field>
              </div>
            }
          </permission-block>
          <permission-block [oneOfRoles]="['Kunde']">
            <div
              style="display: inline-block; margin-left: 10px">
              <mat-form-field class="tut_warenkorb_sortierkennzeichen" appearance="outline"
                              style="margin-top: 5px; width: 100px" [maxlength]="3">
                <mat-label matTooltip="Sortierkennzeichen">SK</mat-label>
                <mat-select [(ngModel)]="warenkorb.sortierkennzeichen"
                            (selectionChange)="sortierkennzeichen_edited = true;">
                  <mat-option [value]="null">-</mat-option>
                  @for (sortierkennzeichen of sortierkennzeichenListe; track sortierkennzeichen) {
                    <mat-option [value]="sortierkennzeichen">{{ sortierkennzeichen }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </permission-block>

          @if (valuta_edited || reTage_edited || note_edited || liefernAb_edited || externeKopfreferenz_edited || sortierkennzeichen_edited) {
            <button (click)="saveWarenkorb()" mat-icon-button>
              <svg-icon>speichern</svg-icon>
            </button>
          }
        </div>
        <div>
          @if ((group|async) === false) {
            <table class="table table-hover2" [class.table-striped]="!ajax_mode">
              <tbody [parent]="this" [positionen]="positions" [summe]="getSumme()" [warenkorb]="warenkorb"
                     [(selectedEntries)]="selectedEntries" [selectMode]="selectMode"
                     (selectedEntriesChange)="selectedEntriesChange.emit($event)"
                     [ajax_mode]="ajax_mode" [show_category]="!group_val" [positionenFilter]="filter"
                     (validChange)="validChange($event)" [active_fields]="active_fields"
                     [supplierId]="warenkorb.supplierId"
                     [positionVerfuegbarkeiten]="positionVerfuegbarkeiten"
                     [showAktionenDefault]="showAktionenDefault"
                     warenkorb-table>
              </tbody>
            </table>
          }
          @if ((group|async) === true) {
            <table class="table table-hover2" [class.table-striped]="!ajax_mode">
              @for (kat of kategorien|async; track kat.view_slug) {
                <tbody [parent]="this" [positionen]="kat.positionen"
                       [(selectedEntries)]="selectedEntries" [selectMode]="selectMode"
                       (selectedEntriesChange)="selectedEntriesChangeExec(kat.view_slug, $event)"
                       [show_category]="!group_val" [title]="kat.label" [positionenFilter]="filter"
                       [warenkorb]="warenkorb" [summe]="getKatSumme(kat)" [ajax_mode]="ajax_mode"
                       (validChange)="validChange($event)" [active_fields]="active_fields"
                       [supplierId]="warenkorb.supplierId"
                       [positionVerfuegbarkeiten]="positionVerfuegbarkeiten"
                       [showAktionenDefault]="showAktionenDefault"
                       warenkorb-table>
                </tbody>
              }
              @if ((kategorien|async)?.length == 0) {
                <tbody>
                <tr>
                  <td>
                    <div
                      style="vertical-align: middle; width: 100%; background-color: white; text-align: center; padding-top: 40px">
                      <svg-icon style="width: 100px; height: 100px; font-size: 100px">traurig</svg-icon>
                      <br>
                      <div style="height: 100px; font-size: 16px; font-weight: bold;">
                        Der Warenkorb ist leer.
                      </div>
                    </div>
                  </td>
                </tr>
                </tbody>
              }
            </table>
          }
          @if (!widget_mode && !ajax_mode) {
            @if (cfg.domainconfig?.warenkorb_information_text?.trim(); as informationText) {
              <div class="warenkorb-information" role="note">{{ informationText }}</div>
            }
          }
        </div>
      </ngx-simplebar>
    </div>
    <div [class.sendbuttonbox]="!ajax_mode" style="text-align: center" [style.bottom]="send_position_from_bottom"
         [class.posfixed]="send_button_pos_fixed">
      <button [disabled]="(kategorien|async)?.length == 0 || !(valid|async)" class="checkbutton tut_warenkorb_check"
              mat-raised-button
              (click)="vfCheckWk($event)">
        <svg-icon>verfuegbarkeitsabfrage</svg-icon>
        Verfügbarkeitsabfrage
      </button>
      @if (!(usvc.user$|async)?.readonly_impersonated) {
        <button [disabled]="(kategorien|async)?.length == 0 || !(valid|async) || (countReadyToSend|async) == 0"
                class="sendbutton tut_warenkorb_send"
                mat-raised-button
                (click)="sendWk($event)">
          <svg-icon>senden</svg-icon>
          Warenkorb absenden
          <span *ngIf="(countReadyToSend|async) != warenkorb.entries.length">
            ( {{ (countReadyToSend|async) }} / {{ warenkorb.entries.length }} )
          </span>
        </button>
      }
    </div>
  </div>
}

